export const getMinutes = (interval = 5) => {
  const minutes = Array(60 / interval);
  return Array.from(minutes.keys(), (value, index) => {
    return { id: index * interval, name: value * interval };
  });
};
